module.exports = __webpack_public_path__ + "media/components/wind-icon/static/N@2x-1a61a9d3f74d653a85c2b449862baecb.png";